import firebase from 'firebase';
import i18n from 'i18next';
import { GetState } from 'zustand';
import { SetState } from 'zustand/vanilla';
import { environment } from '../../environments/environment';
import useAuthStore from '../useAuth';
import { UseFirebaseStore } from './models';

export const ON_ERROR: number = -1;

export function initializeFirebase(set: SetState<UseFirebaseStore>, get: GetState<UseFirebaseStore>): UseFirebaseStore['initializeFirebase'] {
  return () => {
    firebase.initializeApp(environment.firebase);

    const messaging = firebase.messaging();

    set({ messaging });
  };
}

export function setToken(set: SetState<UseFirebaseStore>, get: GetState<UseFirebaseStore>): UseFirebaseStore['setToken'] {
  return (token) => {
    set({ token });

    const isLogged = useAuthStore.getState().isLogged;

    if (!isLogged)
      return;

    useAuthStore.getState().updateUserFromAPI({
      fcmToken: token,
    }).catch(console.error);
  };
}

export function getFirebaseToken(set: SetState<UseFirebaseStore>, get: GetState<UseFirebaseStore>): UseFirebaseStore['getFirebaseToken'] {
  return async function (serviceWorkerRegistration?: ServiceWorkerRegistration) {
    const messaging = get().messaging;

    const token = await messaging.getToken({
      vapidKey: environment.config.firebasePubKey,
      serviceWorkerRegistration,
    }).catch(error => {
      console.log(error);

      return ON_ERROR;
    });

    if (token === ON_ERROR)
      throw new Error(i18n.t('firebase.errorOnGetToken'));

    if (typeof token !== 'string')
      throw new Error(i18n.t('firebase.requestPermission'));

    return token;
  }
}
